import {
  createBrowserRouter,
  Navigate,
  RouterProvider as ReactRouterDomProvider,
} from 'react-router-dom';

import { Routes } from '@/constants';
import {
  AnonymousSessionLoader,
  AuthSessionLoader,
  RouterErrorElement,
  SessionLoader,
} from '@/containers';
import {
  AcceptInvite,
  AdminContent,
  CertificateDownload,
  CPACanada,
  CPDRequirements,
  Discover,
  EmailPreferences,
  Episode,
  EpisodeAssessment,
  ForgotPassword,
  LearningPath,
  LearningPaths,
  LearningPathsHome,
  LearningPathsInProgress,
  LearningPathsRecommended,
  LearningPathsTopics,
  Library,
  Login,
  Logout,
  MyLumiq,
  Pricing,
  Profile,
  PurchaseSuccess,
  RecoverAccount,
  Register,
  Reporting,
  ResetPassword,
  Search,
  ShareWithAFriend,
  Tracker,
  ValidateInvite,
  ValidateOffer,
  VerifyEmail,
} from '@/pages';

import { MemberManagement } from '../pages/MemberManagement';

// TODO: is there a way we can reuse the routes config from constants/routes.js in here?
const router = createBrowserRouter([
  {
    path: Routes.ROOT,
    element: <SessionLoader />,
    errorElement: <RouterErrorElement />,
    children: [
      {
        index: true,
        element: <Navigate to={Routes.DISCOVER + window?.location?.search} />,
      },
      {
        path: Routes.MY_OFFERS,
        element: <Navigate to={Routes.PRICING} />,
      },
      {
        path: '*',
        element: <Navigate to={Routes.DISCOVER + window?.location?.search} />,
      },
      {
        path: Routes.DISCOVER,
        element: <Discover />,
      },
      {
        path: Routes.TECHNICAL,
        element: <Navigate to={Routes.LIBRARY} />,
      },
      {
        // pathless layout so both /learning-paths/* and /learning-path/:id
        // can render inside LearningPaths's Outlet.
        element: <LearningPaths />,
        children: [
          {
            path: Routes.LEARNING_PATHS,
            element: <LearningPathsHome />,
          },
          {
            path: Routes.LEARNING_PATHS_IN_PROGRESS,
            element: <LearningPathsInProgress />,
          },
          {
            path: Routes.LEARNING_PATHS_RECOMMENDED,
            element: <LearningPathsRecommended />,
          },
          {
            path: Routes.LEARNING_PATHS_TOPICS,
            element: <LearningPathsTopics />,
          },
          {
            path: Routes.LEARNING_PATH,
            element: <LearningPath />,
          },
        ],
      },
      {
        path: Routes.LIBRARY,
        element: <Library />,
      },
      {
        path: Routes.PROFILE,
        element: <Profile />,
      },
      {
        path: Routes.EPISODE_ASSESSMENT,
        element: <EpisodeAssessment />,
      },
      {
        path: Routes.EPISODE,
        element: <Episode />,
      },
      {
        path: Routes.MY_LUMIQ,
        element: <MyLumiq />,
      },
      {
        path: Routes.SEARCH,
        element: <Search />,
      },
      {
        path: Routes.TRACKER,
        element: <Tracker />,
      },
      {
        path: Routes.CPD_REQUIREMENTS,
        element: <CPDRequirements />,
      },
      {
        path: Routes.CPA_CANADA,
        element: <CPACanada />,
      },
      {
        path: Routes.PRICING,
        element: <Pricing />,
      },
      {
        path: Routes.PURCHASE_SUCCESS,
        element: <PurchaseSuccess />,
      },
      {
        path: Routes.CERTIFICATE_DOWNLOAD,
        element: <CertificateDownload />,
      },
      {
        path: Routes.MEMBER_MANAGEMENT,
        element: <MemberManagement />,
      },
      {
        path: Routes.REPORTING,
        element: <Reporting />,
      },
      {
        path: Routes.ADMIN_CONTENT,
        element: <AdminContent />,
      },
      {
        path: Routes.LOGOUT,
        element: <Logout />,
      },
      {
        path: Routes.SHARE_WITH_A_FRIEND,
        element: <ShareWithAFriend />,
      },
      {
        path: Routes.EMAIL_PREFERENCES,
        element: <EmailPreferences />,
      },
    ],
  },
  {
    element: <AuthSessionLoader />,
    errorElement: <RouterErrorElement />,
    children: [
      {
        path: Routes.LOGIN,
        element: <Login />,
      },
      {
        path: Routes.REGISTER,
        element: <Register />,
      },
      {
        path: Routes.ACCEPT_INVITE,
        element: <AcceptInvite />,
      },
      {
        path: Routes.VERIFY_EMAIL,
        element: <VerifyEmail />,
      },
    ],
  },
  {
    element: <AnonymousSessionLoader />,
    errorElement: <RouterErrorElement />,
    children: [
      {
        path: Routes.FORGOT_PASSWORD,
        element: <ForgotPassword />,
      },
      {
        path: Routes.RESET_PASSWORD,
        element: <ResetPassword />,
      },
      {
        path: Routes.RECOVER_ACCOUNT,
        element: <RecoverAccount />,
      },
      {
        path: Routes.VALIDATE_INVITE,
        element: <ValidateInvite />,
      },
      {
        path: Routes.VALIDATE_OFFER,
        element: <ValidateOffer />,
      },
      {
        path: Routes.VALIDATE_FREE_TRIAL_OFFER,
        element: <ValidateOffer />,
      },
    ],
  },
]);

export const Router = () => <ReactRouterDomProvider router={router} />;
